import getFeedUrl from '../../lib/settings/getFeedUrl';

import {
  loadPodcast,
  loadPodcastEpisodes,
  loadPodcastEpisodesCount,
  isPodcastNotFoundError,
} from './MainPage.feedApi';

import stringifyError from '../../lib/utils/stringifyError';

import { BiEvent } from '../../lib/bi/types';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import { WidgetPage } from '@wix/podcasts-common/dist/widget';

import { IRoutePageGetInitialPropsArgs } from '../../lib/router/types';
import { getEpisodesPerPage } from '../../selectors/settings';
import { IMainPageInitialProps } from './types';
import {
  feedLoadCompleted,
  feedLoadRequested,
} from '@wix/bi-logger-podcast/v2';

async function getInitialProps({
  isServer,
  req,
  res,
  context,
  params,
}: IRoutePageGetInitialPropsArgs): Promise<IMainPageInitialProps> {
  const { settings, biLogger, biTransaction, config } = context;

  const pageWidth = isServer
    ? Number(req.query.width) || Infinity
    : window.innerWidth;

  const deviceType = ((isServer ? req.query.deviceType : params.deviceType) ||
    'desktop') as TPADeviceType;

  const feedUrl = getFeedUrl(settings, config.defaultFeedUrl);
  const episodesPerPage = getEpisodesPerPage(settings, deviceType, pageWidth);

  const transaction = biTransaction.start(BiEvent.FEED_LOAD_REQUESTED);
  const biParams = {
    feedId: feedUrl,
    pageType: WidgetPage.MAIN,
    isServerSide: isServer,
    correlationId: transaction.id,
  };

  try {
    biLogger.report(feedLoadRequested(biParams));

    const [podcast, episodes, episodesCount] = await Promise.all([
      loadPodcast({ url: feedUrl }),
      loadPodcastEpisodes({
        url: feedUrl,
        limit: episodesPerPage,
      }),
      loadPodcastEpisodesCount({ url: feedUrl }),
    ]);

    biLogger.report(
      feedLoadCompleted({
        ...biParams,
        loadTime: biTransaction.end(transaction).duration,
        success: true,
      }),
    );

    return {
      params,
      podcast,
      episodes,
      episodesCount,
    };
  } catch (error) {
    biLogger.report(
      feedLoadCompleted({
        ...biParams,
        loadTime: biTransaction.end(transaction).duration,
        success: false,
        errorType: stringifyError(error),
      }),
    );

    if (isPodcastNotFoundError(error)) {
      error.statusCode = 404;
    }

    if (res && error.statusCode) {
      res.statusCode = error.statusCode;
    }

    console.error(error);

    return { error };
  }
}

export default getInitialProps;
